var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.loading)?[_c('v-overlay',{attrs:{"color":"white"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"32"}})],1)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }